import React, {useContext, useState, useEffect} from 'react'
import AuthContext from '../../context/AuthContext'
import { Link, Redirect,} from "react-router-dom";
const { REACT_APP_DEV_API_URL, REACT_APP_PROD_API_URL, NODE_ENV } = process.env;

const API_URL = 
  NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL;

const PasswordResetConfirm = ({ match}) => {
    let {passwordResetConfirm, user, errorMessage, successMessage} = useContext(AuthContext)
    let [passNoMatch, setPassNoMatch] = useState(false)

    let [clientIP, setClientIP] = useState("")

    let profileId = match.params.id
    let token = match.params.token

    let noMatchError = ()=> {
        if (document.getElementById('password1').value != document.getElementById('password2').value) {
            setPassNoMatch(true)
        }else{
            setPassNoMatch(false)
        }
    }

    let getClientIP = async () => {
      let response = await fetch(`${API_URL}/tools/ip/`)
      let data = await response.json()
      setClientIP(data)
  }

    useEffect(() => {
      document.title = "Forgot Password | WillowBMS"
      getClientIP()
    }, [])
    
    return (
        <div className="antialiased border-top-wide border-primary d-flex flex-column">
            {user && <Redirect to="/" />}
    <div className="page page-center">
      <div className="container-tight py-4">
        <div className="text-center mb-4">
          <Link to=""><img src="./static/logo.svg" height="36" alt=""/></Link>
        </div>
        <form onSubmit={passwordResetConfirm} className="card card-md" autoComplete="off">
          <div className="card-body">
            <h2 className="card-title text-center mb-4">Reset Password</h2>
            {errorMessage != null && <p className='invalid-feedback d-block text-center'>{errorMessage}</p>}
            {successMessage != null && <p className='valid-feedback d-block text-center'>{successMessage}</p>}
            <div className="mb-2">
              <label className="form-label">New Password</label>
              <input onChange={()=>{noMatchError()}} type="password" id="password1" name="password1" className="form-control mb-2" placeholder="Enter your email address" required/>
              <label className="form-label">Confirm New Password</label>
              <input onChange={()=>{noMatchError()}} type="password" id="password2" name="password2" className="form-control mt-2" placeholder="Enter your email address" required/>
              {passNoMatch == true && <div className='invalid-feedback d-block'>Passwords do not match</div>}
              <input type="text" hidden name="id" value={profileId} readOnly required />
              <input type="text" hidden name="token" value={token} readOnly required />
            </div>
            <div className="form-footer">
              <button type="submit" className="btn btn-primary w-100">
                  Confirm Password Reset
              </button>
              <div className="form-hint mt-1"><span className='strong'>Current IP: </span>{clientIP}</div>
            </div>
          </div>
        </form>
        <div className="text-center text-muted mt-3">
          Wait! I remember! Send me back to the <Link to="/login" tabIndex="-1"> Sign In </Link> page!
        </div>
      </div>
    </div>

    <script src="./dist/js/tabler.min.js"></script>
  </div>
    )
}

export default PasswordResetConfirm